/**
 * Get Geoman style configuration based on tile type
 * @param {'os' | 'satellite'} tileType
 * @returns {GmOptionsPartial}
 */
export const getGeomanStyle = (tileType = 'os') => {
  // Use red for satellite tiles, blue for OS tiles
  const isSatellite = tileType === 'satellite'
  const lineColor = isSatellite ? '#FF0000' : '#3388ff' // Red for satellite, blue for OS
  const fillColor = isSatellite ? '#FF0000' : '#3388ff'
  const fillOpacity = 0.2
  const treeIconColour = isSatellite ? 'red' : 'blue'

  return {
    layerStyles: {
      marker: {
        gm_main: [
          {
            type: 'symbol',
            layout: {
              'icon-image': `tree-icon-${treeIconColour}`,
              'icon-anchor': 'center'
            }
          }
        ],
        gm_temporary: [
          {
            type: 'symbol',
            layout: {
              'icon-image': `tree-icon-${treeIconColour}`,
              'icon-anchor': 'center'
            }
          }
        ]
      },
      polygon: {
        gm_main: [
          {
            type: 'fill',
            paint: {
              'fill-color': fillColor,
              'fill-opacity': fillOpacity
            }
          },
          {
            type: 'line',
            paint: {
              'line-color': lineColor,
              'line-width': 3
            }
          }
        ],
        gm_temporary: [
          {
            type: 'fill',
            paint: {
              'fill-color': fillColor,
              'fill-opacity': fillOpacity * 0.5
            }
          },
          {
            type: 'line',
            paint: {
              'line-color': lineColor,
              'line-width': 2,
              'line-dasharray': [2, 2]
            }
          }
        ]
      },
      line: {
        gm_main: [
          {
            type: 'line',
            paint: {
              'line-color': lineColor,
              'line-width': 3
            }
          }
        ],
        gm_temporary: [
          {
            type: 'line',
            paint: {
              'line-color': lineColor,
              'line-width': 2,
              'line-dasharray': [2, 2]
            }
          }
        ]
      }
    },
    controls: {
      draw: {
        polygon: { uiEnabled: false },
        marker: { uiEnabled: false }
        // need to enable otherwise add mode won't work
        // keep other draw tools disabled/hidden by omission
      },
      helper: {
        snapping: { uiEnabled: false },
        zoom_to_features: { uiEnabled: false }
      }
    }
  }
}
